import { useState } from 'react';
import WeightPriceListService from './WeightPriceListService';

function useManageWeightPriceList() {
    const [weightPriceItems, setWeightPriceItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshWeightPriceItems = async (status = 'all') => {
        setIsLoading(true);
        try {
            const response = await WeightPriceListService.getWeightPriceItems(status);
            const data = response.data.data;
            setWeightPriceItems(Array.isArray(data) ? data : []);
            setError(null);
        } catch (err) {
            console.log(err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const addWeightPriceItem = async (weightPriceData) => {
        let result = true;
        setIsLoading(true);
        try {
            await WeightPriceListService.addWeightPriceItem(weightPriceData);
            refreshWeightPriceItems();
        } catch (err) {
            result = false;
            setError(err.response?.data?.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result;
    };

    const editWeightPriceItem = async (id, updatedData) => {
        setIsLoading(true);
        try {
            await WeightPriceListService.editWeightPriceItem(id, updatedData);
            refreshWeightPriceItems();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const deleteWeightPriceItem = async (id) => {
        setIsLoading(true);
        try {
            await WeightPriceListService.deleteWeightPriceItem(id);
            refreshWeightPriceItems();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        weightPriceItems,
        isLoading,
        error,
        addWeightPriceItem,
        editWeightPriceItem,
        deleteWeightPriceItem,
        refreshWeightPriceItems
    };
}

export default useManageWeightPriceList;

